export default __webpack_public_path__ + "c0cbca33b3ac5e365f623a82a635f4d4.jpg";